import $ from 'jquery';
import * as Sentry from '@sentry/browser';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/blur-up/ls.blur-up';

window.lazySizes = lazySizes;
lazySizes.cfg.blurupMode = 'auto';
window.Sentry = Sentry;
window.jQuery = $;
window.$ = $;